import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import {
// useGetUserQuery,
useUpdatePortfolioVentureLinkMutation, useListPortfolioVentureLinksLazyQuery, useGetAccountQuery, AccountCategory, Module } from '~/types/types';
import { modules as allModules } from '~/assets/helper/functions';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditPortfolioVentureLink',
  props: {
    item: {
      type: Object,
      required: true
    },
    referenceId: {
      type: String,
      required: true
    },
    accountType: {
      // is the item a venture or a portfolio
      type: String,
      required: false,
      default: function _default() {
        return AccountCategory.Venture;
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var linkModuleOptions = computed(function () {
      return allModules.filter(function (item) {
        return item.value !== Module.Review;
      });
    });

    // const { result: userResult } = useGetUserQuery()
    // const user = computed(
    //   () => userResult.value?.getUser || { locale: 'en-US', isAdmin: false },
    // )
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return ((_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) || {};
    });
    var dialogOpen = ref(false);
    var filters = computed(function () {
      if (props.accountType === AccountCategory.Venture) {
        return {
          ventureIds: [props.referenceId],
          portfolioId: props.item.id
        };
      } else {
        return {
          ventureIds: [props.item.id],
          portfolioId: props.referenceId
        };
      }
    });
    var _useListPortfolioVent = useListPortfolioVentureLinksLazyQuery({
        filters: filters.value
      }),
      linksResult = _useListPortfolioVent.result,
      load = _useListPortfolioVent.load,
      refetch = _useListPortfolioVent.refetch,
      loading = _useListPortfolioVent.loading;
    var link = computed(function () {
      var _linksResult$value;
      var linkData = (_linksResult$value = linksResult.value) === null || _linksResult$value === void 0 ? void 0 : _linksResult$value.listPortfolioVentureLinks[0];
      if (linkData) {
        return linkData;
      }

      // Default link structure based on account type
      if (props.accountType === AccountCategory.Venture) {
        return {
          ventureId: props.referenceId,
          portfolioId: props.item.id,
          modules: []
        };
      } else {
        return {
          ventureId: props.item.id,
          portfolioId: props.referenceId,
          modules: []
        };
      }
    });
    watch(dialogOpen, function (newVal) {
      if (newVal) {
        nextTick(function () {
          return load() || refetch();
        });
      }
    });
    var _useUpdatePortfolioVe = useUpdatePortfolioVentureLinkMutation(),
      updateLink = _useUpdatePortfolioVe.mutate,
      onUpdateDone = _useUpdatePortfolioVe.onDone;
    onUpdateDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    return {
      __sfc: true,
      linkModuleOptions: linkModuleOptions,
      props: props,
      accountResult: accountResult,
      account: account,
      dialogOpen: dialogOpen,
      filters: filters,
      linksResult: linksResult,
      load: load,
      refetch: refetch,
      loading: loading,
      link: link,
      updateLink: updateLink,
      onUpdateDone: onUpdateDone
    };
  }
});